import ContentLoader from 'react-content-loader';
import *as React from 'react';

export const ContentFilterLoader =props=>{
        return(<>
            {props.count && props.count > 0 && (
                Array.from({ length: props.count }, (_, i) => (
                <ContentLoader
                key={i+1} 
                height={240}
                width={400}
                speed={2}>
                <rect x="0" y="78" rx="8" ry="8" width="120" height="12" /> 
                <rect x="0" y="128" rx="8" ry="8" width="120" height="12" /> 
                <rect x="0" y="178" rx="8" ry="8" width="120" height="12" /> 
                <rect x="0" y="228" rx="8" ry="8" width="120" height="12" /> 
                
                <rect x="321" y="24" rx="8" ry="8" width="65" height="12" /> 
                <rect x="183" y="24" rx="8" ry="8" width="65" height="12" /> 

                <rect x="205" y="68" rx="0" ry="0" width="20" height="20" /> 
                <rect x="345" y="68" rx="0" ry="0" width="20" height="20" /> 

                <rect x="205" y="118" rx="0" ry="0" width="20" height="20" /> 
                <rect x="345" y="118" rx="0" ry="0" width="20" height="20" /> 
                
                <rect x="205" y="168" rx="0" ry="0" width="20" height="20" /> 
                <rect x="345" y="168" rx="0" ry="0" width="20" height="20" /> 

                <rect x="205" y="218" rx="0" ry="0" width="20" height="20" /> 
                <rect x="345" y="218" rx="0" ry="0" width="20" height="20" /> 

            </ContentLoader>
                          ))
                      )}</>)
    }